import { render, staticRenderFns } from "./AiPricingView.vue?vue&type=template&id=00eca52c&scoped=true"
import script from "./AiPricingView.vue?vue&type=script&lang=js"
export * from "./AiPricingView.vue?vue&type=script&lang=js"
import style0 from "./AiPricingView.vue?vue&type=style&index=0&id=00eca52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eca52c",
  null
  
)

export default component.exports